import { render, staticRenderFns } from "./PartnershipL.vue?vue&type=template&id=22b25ffe&scoped=true"
import script from "./PartnershipL.vue?vue&type=script&lang=js"
export * from "./PartnershipL.vue?vue&type=script&lang=js"
import style0 from "./PartnershipL.vue?vue&type=style&index=0&id=22b25ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b25ffe",
  null
  
)

export default component.exports